export const ScanRegionStatus = {
    Requested: 'Requested',
    Approved: 'Approved',
    Declined: 'Declined',
    OrderPending: 'OrderPending',
    ActionNeeded: 'ActionNeeded',
    Completed: 'Completed',
    Cancelled: 'Cancelled'
};
export type ScanRegionStatus = typeof ScanRegionStatus[keyof typeof ScanRegionStatus];

export const ImagingRequestStatus = {
    Unknown: 'Unknown',
    ActionNeeded: 'ActionNeeded',
    ReferralInProgress: 'ReferralInProgress',
    ApprovedOrDeclined: 'ApprovedOrDeclined',
    ReceivingOrderDetails: 'ReceivingOrderDetails',
    ReadyToReport: 'ReadyToReport',
    ReportCompleted: 'ReportCompleted',
    Cancelled: 'Cancelled'
};
export type ImagingRequestStatus = typeof ImagingRequestStatus[keyof typeof ImagingRequestStatus];

export const ImagingRequestType = {
    Invalid: 'Invalid',
    ReferralWithoutOrders: 'ReferralWithoutOrders',
    ReferralWithOrders: 'ReferralWithOrders',
    OrderWithoutReferral: 'OrderWithoutReferral'
};
export type ImagingRequestType = typeof ImagingRequestType[keyof typeof ImagingRequestType];
